var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiqueurIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.625 84.8444C117.649 84.8848 117.662 84.931 117.662 84.9781V150C117.662 153.314 114.975 156 111.662 156H69C65.6863 156 63 153.314 63 150V84.9805C63 84.932 63.0143 84.8846 63.0412 84.8443V84.8443C63.0695 84.802 63.0839 84.753 63.0849 84.7021C63.094 84.2361 63.2477 81.6668 65.42 77.2231C67.8231 72.29 73.34 69.4638 73.8392 69.0746C74.3385 68.6854 79.3223 66.1723 78.8738 55.0877C78.8738 52.6571 78.9031 38.3066 78.9205 29.9782C78.9274 26.6695 81.6115 24 84.9202 24H95.7413C99.05 24 101.734 26.6695 101.741 29.9782C101.758 38.3066 101.788 52.6571 101.788 55.0877C101.339 66.1723 106.323 68.6854 106.822 69.0746C107.322 69.4638 112.838 72.29 115.25 77.2231C117.425 81.6731 117.576 84.2434 117.585 84.7041C117.586 84.7537 117.599 84.8019 117.625 84.8444V84.8444Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8086 39.3486H101.924",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7109 94.9928C79.7109 88.7312 84.7879 83.6543 91.0494 83.6543C97.3109 83.6543 102.388 88.7312 102.388 94.9928",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.662 92.4287H102.389",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7115 92.4287H63",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.662 137.943H63",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiqueurIcon);
export default __webpack_public_path__ + "static/media/liqueur-icon.2089971f54bdbcb3f732e20156fb0dd1.svg";
export { ForwardRef as ReactComponent };